module.exports = __webpack_public_path__ + "img/v19.9dccd7c7.jpg";